import { render, staticRenderFns } from "./EventsMap.vue?vue&type=template&id=0beed3f0&scoped=true"
import script from "./EventsMap.vue?vue&type=script&lang=js"
export * from "./EventsMap.vue?vue&type=script&lang=js"
import style0 from "./EventsMap.vue?vue&type=style&index=0&id=0beed3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beed3f0",
  null
  
)

export default component.exports